<template>
  <f7-chip
          @click="onClick"
          :class="{'tag-chip': true, 'tag-chip-compact': compact, 'active': !noClick}"
          :text="tag.name || tag.body"
          :deleteable="added"
          color="gray"
          :outline="tag.pseudo"
  />
</template>

<script>
  export default {
    name: "TagChip",
    props: {
      tag: {
        type: Object,
        required: true,
      },
      added: {
        type: Boolean,
        default: false,
      },
      compact: {
        type: Boolean,
        default: false,
      },
      noClick: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      onClick () {
        this.$emit('click', this)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tag-chip {
    // TODO: use non-px unit for font-size
    font-size: 14px;
    line-height: 1;
    &.active {
      cursor: pointer;
      transition: opacity .2s;

      @media not all and (hover: none) {
        &:hover {
          opacity: 0.5;
        }
      }
    }

    .md &.tag-chip-compact {
      height: 18px;  // font-size + 4px (2px either side)
    }
  }
</style>
